<div class="modal-header">
  <h5 class="modal-title">
    Push Event – {{ batch?.BatchName }}
  </h5>
  <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div class="row inline-form">
    <div class="col-lg-2 col-md-2 col-sm-3 col-12">
      <div class="form-group mb-2">
        <label class="form-label" for="eventName">Event Type</label>
        <select class="form-select" [(ngModel)]="eventName" (change)="onEventTypeChange()" name="eventName">
          <!-- <option value="">Select Event</option>
          <option value="I">Industry</option>
          <option value="C">Company</option>
          <option value="P">Product</option>
          <option value="F">Feature</option>
          <option value="S">Segment</option> -->
          <option *ngFor="let c of eventTypes" [value]="c.EventName">{{ c.EventName }}</option>
        </select>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-3 col-12" *ngIf="eventType == 'C' || eventType == 'P'">
      <div class="form-group mb-2">
        <label class="form-label" for="companyName">Select Company</label>
        <select class="form-select" [(ngModel)]="selectedCompany" name="companyName"
          (ngModelChange)="onCompanyChange()">
          <option *ngFor="let c of companies" [value]="c.CompanyName">{{ c.CompanyName }}</option>
        </select>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-3 col-12" *ngIf="eventType == 'P'">
      <div class="form-group mb-2">
        <label class="form-label" for="productName">Select Product</label>
        <select class="form-select" [(ngModel)]="selectedProduct" name="productName">
          <option *ngFor="let p of products" [value]="p.ProductName">{{ p.ProductName }}</option>
        </select>
      </div>
    </div>


    <div class="col-lg-2 col-md-2 col-sm-3 col-12" *ngIf="eventType == 'F'">
      <div class="form-group mb-2">
        <label class="form-label" for="feautureName">Select Feature</label>
        <select class="form-select" [(ngModel)]="selectedFeatures" name="feautureName">
          <option *ngFor="let p of features" [value]="p.FeatureName">{{ p.FeatureName }}</option>
        </select>
      </div>
    </div>


    <div class="col-lg-2 col-md-2 col-sm-3 col-12" *ngIf="eventType === 'S'">
      <div class="form-group mb-2">
        <label class="form-label" for="segmentName">Select Segment</label>
        <select class="form-select" [(ngModel)]="selectedSegment" name="segmentName">
          <option *ngFor="let p of segments" [value]="p">{{ p }}</option>
        </select>
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-3 col-12">
      <div class="form-group mb-2">
        <label class="form-label" for="value">Value</label>
        <input class="form-control" [(ngModel)]="value" name="value" id="value" />
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-3 col-12">
      <div class="form-group mb-3">
        <label class="form-label" for="subRound">Sub Round</label>
        <input class="form-control" [(ngModel)]="subRound" id="subRound" name="subRound" />
      </div>
    </div>
    <div class="col-lg-2 col-md-2 col-sm-3 col-12"
      style="display: flex; justify-content: flex-start;align-items: center;">
      <button class="btn btn-primary btn-shadow btn-sm add-event-btn" (click)="addEvent()"><i
          class="fa fa-solid fa-circle-plus"></i> Add Event</button>
    </div>
  </div>

  <div class="row event-table-list">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <!-- TABLE -->
      <div class="table-scroll">
        <table class="table table-striped event-table"> <!--*ngIf="eventList.length"-->
          <thead>
            <tr>
              <th>Event Name</th>
              <th>Company</th>
              <th>Product</th>
               <th>Feature</th>
              <th>Segment</th>
              <th>Value</th>
              <th>SubRound</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let e of eventList; let i = index">
              <td>{{ e.EventName }}</td>
              <td>{{ e.EventCompanyName || '-' }}</td>
              <td>{{ e.EventProductName || '-' }}</td>
               <td>{{ e.EventFeature || '-' }}</td>
              <td>{{ e.EventSegment || '-' }}</td>
              <td>{{ e.EventVal }}</td>
              <td>{{ e.EventSR }}</td>
             
              <td style="text-align:right;">
                <button class="btn btn-mini btn-danger btn-shadow mx-1" title="Delete Row"
                  (click)="openConfirmationModal(confirmationModal, i)">
                  <i class="fa fa-solid fa-trash-can"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="!eventList.length">
              <td colspan="8" class="text-center text-muted">
                No events added yet
              </td>
            </tr>
          </tbody>

        </table>
      </div>
    </div>
  </div>


</div>

<div class="modal-footer">
  <button class="btn btn-success" (click)="submitAll()">
    <i class="fa fa-regular fa-floppy-disk"></i> Submit
  </button>
</div>

<!-- Confirmation Modal -->
<ng-template #confirmationModal let-modal>
  <div class="modal-body">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="delete-icon">
          <img src="/assets/img/common-icons/delete-1.gif" />
        </div>
        <h4 class="title-txt">Confirm Delete!</h4>
        <p class="title-sub-txt">
          Are you sure, you want to delete this Entry?
        </p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger btn-shadow mx-1" (click)="modal.close('Yes')">
      <i class="fa fa-regular fa-circle-check mx-2"></i>Yes
    </button>
    <button type="button" class="btn btn-secondary btn-shadow mx-1" (click)="modal.close('No')">
      <i class="fa fa-solid fa-circle-xmark mx-2"></i>No
    </button>
  </div>
</ng-template>